'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moveto = require('moveto');

var _moveto2 = _interopRequireDefault(_moveto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollToLocation = function scrollToLocation() {
  if (typeof global.window !== 'undefined') {
    var hash = global.window.location.hash;

    if (hash !== '') {
      var retries = 0;
      var id = hash.replace('#', '');
      var scroll = function scroll() {
        retries += 0;
        if (retries > 50) return;
        var element = document.getElementById(id);
        if (element) {
          var moveTo = new _moveto2.default({
            tolerance: 40
          });

          moveTo.move(element);
        } else {
          setTimeout(scroll, 100);
        }
      };
      scroll();
    }
  }
};

var ScrollToHash = function (_React$Component) {
  (0, _inherits3.default)(ScrollToHash, _React$Component);

  function ScrollToHash() {
    (0, _classCallCheck3.default)(this, ScrollToHash);
    return (0, _possibleConstructorReturn3.default)(this, (ScrollToHash.__proto__ || (0, _getPrototypeOf2.default)(ScrollToHash)).apply(this, arguments));
  }

  (0, _createClass3.default)(ScrollToHash, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      scrollToLocation();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollToHash;
}(_react2.default.Component);

exports.default = ScrollToHash;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-navigation-stacks/build/ScrollToHash.js
// module id = 225
// module chunks = 0